import React from 'react';
import PropTypes from 'prop-types';

const defaultOpts = {
  timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric', year: 'numeric',
};

const dateToLocaleStr = (dateStr, opts) => new Date(dateStr).toLocaleString(
  'default',
  opts,
);

const timeRangeStr = (interviewTime) => {
  const startStr = `${interviewTime.date} ${interviewTime.start_time}`;
  const startMoment = moment(startStr);
  const endStr = `${interviewTime.date} ${interviewTime.end_time}`;
  const endMoment = moment(endStr);

  return `${startMoment.format('h:mma')} - ${endMoment.format('h:mma')}`;
};

function InterviewTimeRange({ interviewTime, opts = defaultOpts, containerClassName = '' }) {
  return (
    <div className={containerClassName}>
      {dateToLocaleStr(interviewTime.date, opts)}
      &nbsp;
      &#183;
      &nbsp;
      {timeRangeStr(interviewTime)}
    </div>
  );
}

InterviewTimeRange.propTypes = {
  interviewTime: PropTypes.shape({
    date: PropTypes.string.isRequired,
    start_time: PropTypes.string.isRequired,
    end_time: PropTypes.string.isRequired,
  }).isRequired,
  opts: PropTypes.shape({}),
  containerClassName: PropTypes.string,
};

InterviewTimeRange.defaultProps = {
  opts: defaultOpts,
  containerClassName: '',
};

export default InterviewTimeRange;
